var render = function render(){var _vm=this,_c=_vm._self._c;return _c('maintenance-page',{attrs:{"page-title":"Vendor","page-icon":"mdi-account-multiple-outline","collection-name":"vendor","done-redirect-url":"/auth/admin/vendor?isHistory=true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }